
import React from 'react';

import Alert from '@material-ui/lab/Alert';
import { Snackbar} from '@material-ui/core';

export const Notification = (props) => {

  const handleSnackbarClose = () => {
    props.setNotification({
      open: false,
      message: '',
      severity: props.severity ? props.severity : 'error'
    })
  }

  return (

    <Snackbar open={props.open} autoHideDuration={3500} onClose={handleSnackbarClose}>
      <Alert onClose={handleSnackbarClose} severity={props.severity}>
        {props.message}
      </Alert>
    </Snackbar>

  )

}

